/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { selectSite } from 'services/site/selectors'
import { Title, SectionTitle, SectionContent, PrivacyLinks, PrivacyWrapper, MobileFooter, WebFooter } from '../util'

const mapStateToProps = (state) => ({
  site: selectSite(state),
})

const mapDispatchToActions = {}

function HelpPage (props) {
  const { site, isMobile } = props
  const appName = site.name || 'MapMyRun'

  return (
    <PrivacyWrapper>
      <Title>
        <FormattedMessage id='privacy_center.help.title' defaultMessage="Why can't I access my account?" />
      </Title>

      <SectionTitle>
        <FormattedMessage id='privacy_center.help.to-continue.title' defaultMessage="To continue using your account" />
      </SectionTitle>

      <SectionContent>
        <FormattedMessage
          id='privacy_center.help.to-continue.content'
          defaultMessage="You will need to accept our Privacy Policy, Terms of Use, and agree to the way we handle your data in order to continue using { appName }."
          values={ { appName } }
        />
      </SectionContent>

      <SectionTitle>
        <FormattedMessage id='privacy_center.help.to-decline.title' defaultMessage="To decline consents" />
      </SectionTitle>

      <SectionContent>
        <FormattedHTMLMessage
          id='privacy_center.help.to-decline.content'
          defaultMessage={`
          <p>Unfortunately, if you do not agree to our Privacy Policy, Terms of Use, and agree to the way we handle your data, we will not be able to provide service through { appName } to you.<br /></p>
          <p>To stop { appName } from collecting and processing your data, you will need to delete your account.<br /></p>

          <p><strong>Deleting your account and data is immediate and permanent</strong></p>
          `}
          values={ { appName } }
        />
      </SectionContent>

      <PrivacyLinks
        exportData={true}
        accountDelete={true}
        contactSupport={true}
        logout={true}
        isMobile={isMobile}
        screenName='consent_help'
      />

      { isMobile ? <MobileFooter /> : <WebFooter /> }
    </PrivacyWrapper>
  )
}

HelpPage.propTypes = {
  site: PropTypes.object,
  isMobile: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToActions)(HelpPage)



// WEBPACK FOOTER //
// ./src/components/privacy_center/help/HelpContent.jsx